import React, { useEffect, useState } from "react";
// import { format } from 'date-fns';
import { enumUtil } from "../../../../utils/Enum";
import { ServerRequestProtected, ServerRequestPublic } from "../../../../utils/ServerDataRequest";
import { useSelector } from "react-redux";
import isNull from "../../../../utils/NullChecking";
import Loader from "../../../shared/Loader/Loader";
import EncounterLeftPortion from "./Components/EncounterLeftPortion/EncounterLeftPortion";
// import EncounterSearch from "./Components/EncounterSearch";
import EncounterRight from "./Components/EncounterRightPortion/TemplateView/EncounterRight"

const Encounter = (props) => {
    const [patientID, setPatientID] = useState(useSelector(state => state.Open_Patient_Tab.find((pt) => pt.active === true))?.data?.id || '')
    const API_URL = enumUtil.controller.PatientEncounter
    const API_URL_Wasabi = enumUtil.controller.Wasabi

    const [templateDataToApply, setTemplateDataToApply] = useState({})

    const [isLoading, setIsLoading] = useState(false);
    const [expandAll, setExplandAll] = useState(true);
    const [isCollapsed, setIsCollapsed] = useState(false);
    // const SearchCriteria = {
    //     "EncounterType": "",
    //     "NoteType": "",
    //     "EncounterDate": format(new Date(), 'MM/dd/yyyy'),
    //     "SeenBy": "",
    //     "Facility": "",
    //     "Status": "Not Signed",
    // }

    // const [searchParam, setSearchParam] = useState(SearchCriteria);
    const [data, setData] = useState([])
    const [isRecordSaved, setIsRecordSaved] = useState(false)
    const [isRecordSavedType, setIsRecordSavedType] = useState('')
    const handleCollapseClick = () => {
        setIsCollapsed(!isCollapsed); // Toggle the collapse state
    };

    const [enCounterData, SetEncounterData] = useState({})


    // const LoaduserImage = async (url) => {
    //     try {
    //         const response = await ServerRequestPublic(API_URL_Wasabi + "/DownloadFile", 'post', {
    //             "BucketPath": url,
    //         }, "Download")
    //         console.log(response.type);

    //         if (response.type === 'application/jpg') {
    //             const blob = response
    //             const objectURL = URL.createObjectURL(blob);
    //             console.log('objectURL', objectURL);
    //             return objectURL

    //         }

    //     } catch (error) {
    //         setIsLoading(false);
    //         throw error;
    //     }
    // }
    const LoaduserImage = async (url) => {
        try {
            const response = await ServerRequestPublic(API_URL_Wasabi + "/DownloadFile", 'post', {
                "BucketPath": url,
            }, "Download");

            console.log(response.type);

            if (response.type === 'application/jpg') {
                const blob = response;
                const objectURL = URL.createObjectURL(blob);
                console.log('objectURL', objectURL);
                return objectURL;
            } else {
                return null;
            }

        } catch (error) {
            console.error('Image load failed:', error);
            // Return null instead of throwing error
            return null;
        }
    };
    const LoadData = async () => {
        setData([]);
        setIsRecordSaved(false);
        setIsRecordSavedType('');
        setIsLoading(true);

        try {
            const response = await ServerRequestProtected(API_URL + "/GetSummaryData", 'post', {
                "ID": patientID,
                "TableName": enumUtil.enumAPITableName.PatientProblemList,
            });

            setIsLoading(false);
            console.log(response,'response');
            
            setData(response);
            if (response?.PatientData?.[0]?.ProfilePictureURL) {
                const imageURL = await LoaduserImage(response.PatientData[0].ProfilePictureURL);
                if (imageURL) {
                    response.PatientData[0].ProfilePictureURL = imageURL;
                } else {
                    // Optionally, set it to null or a fallback image
                    response.PatientData[0].ProfilePictureURL = null;
                }
            }

            SetEncounterData(response?.PatientData?.[0]);

        } catch (error) {
            console.error('Error loading summary data:', error);
            setIsLoading(false);
        }
    };


    useEffect(() => {
        console.log("prop reload Encounter")
        if (!isNull(props.Reload)) {
            let data = props.id
            data.map((item) => {
                if (item.key === 218) {
                    LoadData()
                }
            })
            if (data.length === 0) {
                LoadData()
            }
        }
    }, [props.Reload])

    useEffect(() => {
        if(!isRecordSaved) return;
        LoadData();
    }, [isRecordSaved])

    return (
        <>
            {isLoading ? <Loader /> : null}
            <div className={`ar_encounter_main_screen d-flex ${isCollapsed ? 'collapsed' : ''}`}>
                <div className="collaspe-sidebar d-flex justify-content-center align-items-center position-absolute" onClick={handleCollapseClick}>
                    <i className="icon-angle-left  fs-11"></i>
                </div>
                <div className="encounter_summary col-md-3  position-relative">
                    <EncounterLeftPortion enCounterData={enCounterData} data={data} expandAll={expandAll} setIsRecordSaved={setIsRecordSaved} 
                    setIsRecordSavedType={setIsRecordSavedType} setTemplateDataToApply={setTemplateDataToApply} patientID={patientID} {...props} />
                </div>

                <div className="encounter_detail col-md-9">
                    <EncounterRight
                        templateDataToApply={templateDataToApply} setTemplateDataToApply={setTemplateDataToApply}
                        {...props} patientID={patientID} isRecordSaved={isRecordSaved} 
                        isRecordSavedType={isRecordSavedType}/>
                </div >
            </div >
        </>
    );
}

export default Encounter;
